import type { ButtonHTMLAttributes, DetailedHTMLProps, Ref } from 'react'
import { forwardRef } from 'react'

import clsx from 'clsx'

import '@hotmart/cosmos/dist/button/button.css'
import '@hotmart/cosmos/dist/button/variations/primary.css'
import '@hotmart/cosmos/dist/button/variations/secondary.css'
import '@hotmart/cosmos/dist/button/variations/tertiary.css'
import '@hotmart/cosmos/dist/button/variations/info.css'
import '@hotmart/cosmos/dist/button/variations/small.css'
import '@hotmart/cosmos/dist/button/variations/large.css'
import '@hotmart/cosmos/dist/button/variations/success.css'
import '@hotmart/cosmos/dist/button/variations/danger.css'
import '@hotmart/cosmos/dist/button/variations/custom.css'
import '@hotmart/cosmos/dist/button/variations/block.css'
import '@hotmart/cosmos/dist/button/variations/small.css'
import '@hotmart/cosmos/dist/button/variations/large.css'

export type Variation =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'info'
  | 'success'
  | 'danger'
  | 'warning'
  | 'custom'
  | 'default'

export type Size = 'sm' | 'lg' | 'block'

export type ButtonProps = Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    variation?: Variation
    size?: Size
    active?: boolean
    loading?: boolean
  },
  'ref'
>

const Button = (
  {
    children,
    className,
    size,
    type = 'button',
    variation = 'primary',
    active = false,
    loading = false,
    ...rest
  }: ButtonProps,
  ref: Ref<HTMLButtonElement>
) => {
  const buttonClass = clsx(
    'hot-button',
    {
      [`hot-button--${variation}`]: variation !== 'default',
      [`hot-button--${size}`]: size,
      'hot-button--active': active,
      'hot-button--loading': loading
    },
    className
  )

  return (
    <button ref={ref} className={buttonClass} type={type} {...rest}>
      {children}
    </button>
  )
}

export default forwardRef(Button)
